export default "__VITE_ASSET__BLBxjgGF__"